<ion-content [ngClass]="{ 'custom-ion-content': mobile }">
	<section class="w-full h-full" [ngClass]="{ 'border-wrapper mt-3': mobile }">
		<div [ngClass]="{ hidden: mobile }" class="p-4 border-b-1 border-gray-250">
			<h3 class="text-base font-semibold displa">Notificaciones</h3>
		</div>
		<div *ngIf="newNotificationList">
			<p class="text-sm font-semibold px-4 py-2">Nuevas</p>
			<ion-list>
				<ion-item
					class="font-medium text-sm new-notification"
					*ngFor="let notification of newNotificationList"
					(click)="onSelectNotification(notification)"
					[button]="false"
					[detail]="false"
				>
					<ion-label class="text-sm">
						<h3 *ngIf="notification.detail">
							<span *ngIf="notification.name" class="font-bold">{{ notification.name }}</span>
							{{ notification.detail }}
						</h3>
						<p class="font-normal" *ngIf="notification.time">{{ notification.time }}</p>
					</ion-label>
				</ion-item>
			</ion-list>
		</div>
	
		<div *ngIf="previousNotificationList">
			<p class="text-sm font-semibold px-4 py-2">Previas Notificaciones</p>
			<ion-list>
				<ion-item
					class="font-medium text-sm"
					*ngFor="let notification of previousNotificationList"
					(click)="onSelectNotification(notification)"
					[button]="false"
					[detail]="false"
				>
					<ion-label class="text-sm">
						<h3>
							<span *ngIf="notification.name" class="font-bold">{{ notification.name }}</span>
							{{ notification.detail }}
						</h3>
						<p>{{ notification.time }}</p>
					</ion-label>
				</ion-item>
			</ion-list>
		</div>
	
		<div class="flex justify-center items-center py-3">
			<p class="text-sm font-semibold text-blue-25">Mostrar Todas</p>
		</div>
	</section>
</ion-content>
